import {
  Alert,
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { API_SLUGS, HELPER_TEXTS, ROUTES, STRINGS, TOOLS } from "../../constants";
import { axiosInstance } from "../../services/axios";
import { IAlertState, useAlertState } from "../../store/alertState";

var format = require("string-template");


interface IAddVariableFormValues {
  name: string;
  data: string;
  toolName: string;
  description?: string;
}

interface IAddForm extends RouteComponentProps {
  updateOnly?: boolean;
  defaultFormValues?: any;
  updateUUID?: string;
  callback?: (data: any) => void;
  preventRedirect?: boolean;
}

const AddPolicyForm: FC<IAddForm> = ({
  history,
  match,
  updateOnly = false,
  defaultFormValues,
  updateUUID,
  preventRedirect = false,
  callback = undefined,
}) => {
  const [formValues, setFormValues] = useState({
    name: "",
    data: "",
    toolName: "sift",
    description: "",
    ...defaultFormValues,
  } as IAddVariableFormValues);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(STRINGS.EMPTY);
  const [successMessage, setSuccessMessage] = useState(STRINGS.EMPTY);
  const [hideSave, setHideSave] = useState(false);
  const { setMessage } = useAlertState() as IAlertState;

  useEffect(() => {
    let newDefaultFormValues = { ...formValues };
    if (!updateOnly) {
      setFormValues(newDefaultFormValues);
    }
  }, []);

  const handleChange = async (value: any, type: "name" | "data" | "toolName" | "description") => {
    let newValues = { ...formValues, [type]: value };

    setFormValues(newValues);
  };
  const handleSubmit = async () => {
    if (updateOnly) {
      if (formValues?.name.trim() != "") {
        await updatePolicy(formValues?.name.trim());
      } else {
        setErrorMessage("Please fill all the mandatory fields");
      }
    }
    else {
      if (formValues?.name.trim() != "") {
        await createPolicy(
          formValues?.name.trim()
        );
      } else {
        setErrorMessage("Please fill all the mandatory fields");
      }
    }
  };

  const createPolicy = async (name: string) => {
    try {
      let variableResponse = await axiosInstance.post(
        API_SLUGS.TOOL_POLICIES,
        { ...formValues }
      );
      if (!preventRedirect) {
        history.push(ROUTES.POLICY.replace(":policyId", variableResponse?.data?.id));
      }
      if (callback) {
        callback(variableResponse?.data?.id);
      }
      setMessage({ title: "Policy Created Successfully", type: "success" })
    } catch (error: any) {
      try {
        setErrorMessage(error.response?.data?.message);
      } catch (error: any) { }
    }
  };

  const updatePolicy = async (name: string) => {
    try {
      if (updateUUID) {
        await axiosInstance.patch(
          API_SLUGS.TOOL_POLICY.replace('{id}', updateUUID),
          { name: formValues?.name, description: formValues?.description }
        );
        setMessage({ title: "Policy Updated Successfully", type: "success" })
      }
      if (!preventRedirect) {
        history.push("/policies");
      }
      if (callback) {
        callback({ id: updateUUID });
      }

    } catch (error: any) {
      try {
        setErrorMessage(error.response?.data?.message);
      } catch (error: any) { }
    }
  };

  return (
    <Box sx={{ textAlign: "left" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography
            color="textPrimary"
            sx={{ m: 1, ml: 0, textAlign: "left" }}
            variant="h6"
          >
            Policy Name
          </Typography>
          <TextField
            autoComplete="off"
            sx={{ textAlign: "left" }}
            size="medium"
            fullWidth
            name="Name"
            value={formValues?.name}
            onChange={(e: any) => {
              handleChange(e.target.value, "name");
            }}
            required
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            color="textPrimary"
            sx={{ m: 1, ml: 0, textAlign: "left" }}
            variant="h6"
          >
            Tool Name
          </Typography>
          <Select
            value={"sift"}
            onChange={(e) => handleChange(e.target.value, "toolName")}
            sx={{ minWidth: "10em", textAlign: "left", flex: 1 }}
            disabled={true}
            fullWidth
          >
            {TOOLS.map((tool: any) => (
              <MenuItem key={tool.key} value={tool.key}>
                {tool.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12}>
          <Typography
            color="textPrimary"
            sx={{ m: 1, ml: 0, textAlign: "left" }}
            variant="h6"
          >
            Description
          </Typography>
          <TextField
            autoComplete="off"
            sx={{ textAlign: "left" }}
            multiline
            rows={2}
            value={formValues?.description}
            onChange={(e: any) => {
              handleChange(e.target.value, "description");
            }}
            variant="outlined"
            fullWidth
          />
        </Grid>


        <Box
          sx={{
            display: "flex",
            mt: 3,
            ml: 3
          }}
        >
          {successMessage && successMessage.trim() ? null : (
            <>
              {hideSave ? null :
                (<Button
                  color="primary"
                  size="medium"
                  variant="contained"
                  disabled={isSubmitting}
                  onClick={handleSubmit}
                >
                  {updateOnly ? "Save" : "Proceed"}
                </Button>)
              }
            </>

          )}
        </Box>
      </Grid>
    </Box>
  );
};

export default withRouter(AddPolicyForm);  